var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaAgenda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.25C17.4142 2.25 17.75 2.58579 17.75 3V4H20C21.1046 4 22 4.89543 22 6V6.25H2V6C2 4.89543 2.89543 4 4 4H6.25V3C6.25 2.58579 6.58579 2.25 7 2.25C7.41421 2.25 7.75 2.58579 7.75 3V4H16.25V3C16.25 2.58579 16.5858 2.25 17 2.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.75V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V7.75H2ZM13.6854 14.6538C13.4525 14.8172 13.2857 15.0818 13.2857 15.3804C13.2857 15.591 13.1267 15.7618 12.9305 15.7618H11.0695C10.8733 15.7618 10.7143 15.591 10.7143 15.3804C10.7143 15.0818 10.5475 14.8172 10.3146 14.6538C9.52113 14.0971 9 13.1583 9 12.0939C9 10.3852 10.3431 9 12 9C13.6569 9 15 10.3852 15 12.0939C15 13.1583 14.4789 14.0971 13.6854 14.6538ZM11.3002 16.5287H12.6998C13.0782 16.5287 13.3849 16.8581 13.3849 17.2644C13.3849 17.6706 13.0782 18 12.6998 18H11.3002C10.9218 18 10.6151 17.6706 10.6151 17.2644C10.6151 16.8581 10.9218 16.5287 11.3002 16.5287Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaAgenda);
export default __webpack_public_path__ + "static/media/idea-agenda.2c27bf077a62428af5a64094051f8357.svg";
export { ForwardRef as ReactComponent };